export class HtmlInputConstants {
    public static readonly FIRST_NAME_MIN_LENGTH = 3;
    public static readonly FIRST_NAME_MAX_LENGTH = 30;

    public static readonly LAST_NAME_MIN_LENGTH = 3;
    public static readonly LAST_NAME_MAX_LENGTH = 50;

    public static readonly JOB_TITLE_MIN_LENGTH = 3;
    public static readonly JOB_TITLE_MAX_LENGTH = 50;

    public static readonly STREET_ADDRESS_MIN_LENGTH = 1;
    public static readonly STREET_ADDRESS_MAX_LENGTH = 100;

    public static readonly CITY_MIN_LENGTH = 3;
    public static readonly CITY_MAX_LENGTH = 50;

    public static readonly POSTAL_CODE_MAX_LENGTH = 10;

    public static readonly CALL_SIGN_MAX_LENGTH = 10;

    public static readonly FCC_REGISTRATION_NUMBER_MAX_LENGTH = 10;
}
